export default {
  bulkMessageOwnerName: 'Owner:',
  menuOptionUpdateCampaign: 'Edit Bulk Message',
  openMenuButtonLabel: 'Open the action menu for this job',
  scheduleSummaryTitle: 'Summary',
  timeCreatedLabel: 'Created on',
  title: 'Bulk Message Details'
};
